import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserOrganizationInformationDTO } from "src/app/api/api-types";
import { ApiUrl } from "src/app/api/api-url-helper";
import { RegistrationQueryModel } from "src/app/registration-query.model";
import { RequestService } from "../request.service";

@Injectable({ providedIn: "root" })
export class UserRegistrationService {
  public constructor(private readonly request: RequestService) {}

  public readonly userDetailsChanges = this.request.get({
    path: ApiUrl.CURRENT_USER_INFO,
  });

  public register(
    data: RegistrationQueryModel,
  ): Observable<UserOrganizationInformationDTO | null> {
    return this.request.post({
      path: ApiUrl.CUSTOM_REGISTRATION_FORM,
      body: data.serialize(),
    });
  }
}
